import {EVENT_ACTIONS, trackEvent} from '@src/analytics.js';
import {useCallback} from 'react';
import useAppSection from './useAppSection.js';

export const useTrackSectionEvent = () => {
  const {appSection} = useAppSection();

  return useCallback(
    (action, target, props = {}) => {
      if (!Object.values(EVENT_ACTIONS).includes(action)) {
        throw new Error(`Invalid tracking event action: ${action}`);
      }
      trackEvent(
        [appSection, `${action} ${target}`].filter(p => !!p).join(' - '),
        {
          appSection: appSection || undefined,
          action,
          target,
          ...props,
        },
      );
    },
    [appSection],
  );
};

export default useTrackSectionEvent;
